import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { isMobile } from '../../../screenUtils';
import AddCoworkersInput from '../AddCoworkersInput';
import './SelectOrInviteNewCoworkers.scss';

const createMemberSelectOption = (member) => {
  let label;

  if (member.name) {
    label = member.name;
  } else {
    label = member.email;
  }

  return { value: member.email, label };
};

function Menu(props) {
  const { children } = props;
  return (
    <components.Menu {...props}>
      {children}
      <hr className="mb-0 mt-0" />
      <div className="invite-new-colleague-container body-text-2 me-3 py-3">
        <i className="fas fa-envelope green" />
        <span className="me-3">
          <a
            role="button"
            tabIndex={-1}
            className="invite-new-colleague-link medium-weight"
            onClick={() => props.selectProps.onClickInvite()}
          >
            Invite a new colleague by email
          </a>
        </span>
      </div>
    </components.Menu>
  );
}

class SelectOrInviteNewCoworkers extends Component {
  constructor(props) {
    super(props);

    this.invitableOptionsForSelect = this.createInvitableOptionsForSelect();

    this.state = {
      showInvite: isMobile() || this.invitableOptionsForSelect.length === 0,
      showMenu: false,
    };

    // solely used so we can manually remove focus from the dropdown
    this.selectRef = React.createRef();

    this.handleClickedInviteNew = this.handleClickedInviteNew.bind(this);
    this.setShowMenu = this.setShowMenu.bind(this);
  }

  setShowMenu(show) {
    this.setState({ showMenu: show });
  }

  handleClickedInviteNew() {
    this.setState({ showInvite: true, showMenu: false });
    this.selectRef.current.blur();
  }

  createInvitableOptionsForSelect() {
    const { allCoworkers, excluded } = this.props;

    // pruning current user, reps, and those who are excluded
    const teamMembers = allCoworkers.team_members.filter((member) => !member.is_rep
          && !excluded.includes(member.name)
          && !excluded.includes(member.email));

    return teamMembers.map((member) => createMemberSelectOption(member));
  }

  renderInviteNewColleagues() {
    const { showInvite } = this.state;
    if (!showInvite) {
      return null;
    }

    const {
      newCoworkers,
      onChangeNewCoworkers,
      invitableRoles,
      selectedInvitationRole,
      onChangeNewCoworkersRole,
    } = this.props;

    return (
      <AddCoworkersInput
        emails={newCoworkers}
        onChangeEmails={onChangeNewCoworkers}
        invitableRoles={invitableRoles}
        selectedRole={selectedInvitationRole}
        onChangeSelectedRole={onChangeNewCoworkersRole}
        withMessage={false}
      />
    );
  }

  renderSelectColleagues() {
    if (this.invitableOptionsForSelect.length === 0) {
      return null;
    }

    return (
      <div className="select-container mb-3">
        <div className="select-header medium-weight body-text-2 mb-2">
          Select coworkers
        </div>
        <div className="select-component-wrapper">
          <Select
            ref={this.selectRef}
            menuIsOpen={this.state.showMenu}
            isMulti
            maxMenuHeight={170}
            options={this.invitableOptionsForSelect}
            classNamePrefix="coworkers-select"
            onChange={(newSelection) => this.props.onChangeExistingCoworkers(newSelection)}
            value={this.props.selectedCoworkers}
            components={{ Menu }}
            closeMenuOnSelect={false}
            onMenuOpen={() => this.setShowMenu(true)}
            onMenuClose={() => this.setShowMenu(false)}
            onClickInvite={this.handleClickedInviteNew}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="select-invite-container">
        {this.renderSelectColleagues()}
        {this.renderInviteNewColleagues()}
      </div>
    );
  }
}

SelectOrInviteNewCoworkers.propTypes = {
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  allCoworkers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  onChangeExistingCoworkers: PropTypes.func.isRequired,
  onChangeNewCoworkers: PropTypes.func.isRequired,
  onChangeNewCoworkersRole: PropTypes.func.isRequired,
  selectedCoworkers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  newCoworkers: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedInvitationRole: PropTypes.string.isRequired,
  excluded: PropTypes.arrayOf(PropTypes.string),
};

SelectOrInviteNewCoworkers.defaultProps = {
  excluded: [],
};

export default SelectOrInviteNewCoworkers;
